export default __webpack_public_path__ + "static/media/Nuxeo.c6965be6.png";